import React from "react";
import { withStyles } from "@material-ui/styles";
import { I18n } from "@aws-amplify/core";
import { get, size, map, filter, includes, debounce } from "lodash";

import Tabs from "@material-ui/core/Tabs";
import Grid from "@material-ui/core/Grid";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";

import CustomTab from "../Common/CustomTab2";

import {
  dataPrivacy,
  details,
  photos,
  events,
  //stats,
  historyLog,
  verification,
  temperature,
  notes,
  associations,
} from "../../constants/profiles";
import images from "../../assets/img/images";
import colors from "../../assets/style/colors";

const styles = {
  tabs: {
    height: "50px",
    maxWidth: "calc(100vw - 113px)",
    padding: "0px 24px",
  },
  moreMenu: {
    textTransform: "capitalize",
    cursor: "pointer",
    color: colors.black54,
    "& img": {
      marginLeft: "10px",
    },
  },
  menuItem: {
    padding: "15px 20px",
    fontSize: "1em",
    color: colors.black54,
    "&:hover": {
      backgroundColor: colors.lightGreenBg,
    },
  },
};

const ProfileTabs = (props) => {
  const { classes, tabValue, setTabValue, profile, isMe } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [wrappedTabsNb, setWrappedTabsNb] = React.useState();

  let tabs = [
    { label: I18n.get("profiles_details"), value: details },
    { label: I18n.get("profiles_photos"), value: photos },
    { label: I18n.get("profiles_events"), value: events },
    //{label: I18n.get("profiles_stats"), value: stats},
    { label: I18n.get("profiles_historyLog"), value: historyLog },
    { label: I18n.get("profiles_verification"), value: verification },
  ];

  if (get(profile, ["type", "id"]) === 1) {
    tabs.push({
      label: I18n.get("site_temperatures"),
      value: temperature,
    });
  }

  tabs.push({
    label: I18n.get("profiles_associations"),
    value: associations,
  });
  tabs.push({
    label: `${I18n.get("profiles_notes")} (${props.notesCount})`,
    value: notes,
  });

  if (isMe) {
    tabs.push({
      label: I18n.get("profiles_dataPrivacy"),
      value: dataPrivacy,
    });
  }

  const tabSize = 140;
  const tabContainer = document.getElementById("tab-container");

  React.useEffect(() => {
    if (tabContainer) {
      handleResize(size(tabs), get(tabContainer, ["clientWidth"]), tabSize);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabContainer]);

  const handleResize = (tabsNb, containerWidth, tabSize) => {
    setWrappedTabsNb(tabsNb + 1 - Math.round(containerWidth / tabSize));
  };

  const debouncedHandleResize = debounce(
    (a, b, c) => handleResize(a, b, c),
    200
  );

  React.useEffect(() => {
    const resize = () => {
      const tc = document.getElementById("tab-container");
      debouncedHandleResize(size(tabs), get(tc, ["clientWidth"]), tabSize);
    };
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  });

  return (
    <Grid container className={classes.tabs} id="tab-container">
      <Grid item>
        <Tabs
          value={
            includes(
              map(
                filter(tabs, (t, i) => i < size(tabs) - wrappedTabsNb),
                (t) => t.value
              ),
              tabValue
            )
              ? tabValue
              : false
          }
          onChange={(event, newValue) => {
            setTabValue(newValue);
          }}
          indicatorColor="primary"
        >
          {map(
            filter(tabs, (t, i) => i < size(tabs) - wrappedTabsNb),
            (t, i) => (
              <CustomTab key={i} label={t.label} value={t.value} />
            )
          )}
        </Tabs>
      </Grid>
      {wrappedTabsNb > 0 && (
        <Grid item>
          <Grid
            container
            alignItems="center"
            className={classes.moreMenu}
            onClick={(e) => setAnchorEl(e.currentTarget)}
          >
            <Grid item>{I18n.get("site_more")}</Grid>
            <Grid item className="flexCenter">
              <img src={images.arrowOpenBlack} alt="arrow" height="8px" />
            </Grid>
          </Grid>
          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={() => setAnchorEl(null)}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            getContentAnchorEl={null}
          >
            {map(
              filter(tabs, (t, i) => i >= size(tabs) - wrappedTabsNb),
              (t, i) => (
                <MenuItem
                  key={i}
                  classes={{ root: classes.menuItem }}
                  alignItems="center"
                  onClick={() => {
                    setTabValue(t.value);
                    setAnchorEl(null);
                  }}
                  style={{ paddingLeft: "0px !important" }}
                >
                  {t.label}
                </MenuItem>
              )
            )}
          </Menu>
        </Grid>
      )}
    </Grid>
  );
};

export default withStyles(styles)(ProfileTabs);
